import Link from 'next/link';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

type Props = {
  header;
  elements;
};

const FooterColumn: FunctionComponent<Props> = ({ header, elements }) => {
  return (
    <div className={styles.footerColumn}>
      <h4 className={styles['._header']}>{header}</h4>
      <div>
        {elements?.map((val, key) => {
          const url = val.route?.slug?.current
            ? '/' + val.route?.slug?.current
            : val.route?.content?.carInfo?.slug?.current
            ? val.route?.content?.carInfo?.slug?.current
            : val.slug?.current
            ? '/' + val.slug?.current
            : val.link
            ? val.link
            : '';

          return (
            <Link key={key} href={url} legacyBehavior>
              <a key={key}>{val.title || val.name}</a>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(FooterColumn);
